import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon} from 'fmlx-common-ui';

function NestCard({nestNumber, isInvalid, isSolving, solvingNestId}) {
  const getClassName = () => {
    const classes = ['modal-nest-card'];
    if (isInvalid) classes.push('invalid');
    if (isInvalid && isSolving && nestNumber !== solvingNestId) classes.push('disabled');
    return classes.join(' ');
  };

  const renderIcon = () => (
    <div className="modal-nest-plate-icon">
      <FmlxIcon name="FastPlateVertical" />
      <FmlxIcon name="Cancel" />
    </div>
  );

  return (
    <div className={getClassName()}>
      <h3 className="modal-nest-title">Nest {nestNumber}</h3>
      <div className="modal-nest-content">
        {isInvalid && (
          <div>
            {renderIcon()}
            <div className="modal-nest-error">Incorrect plate</div>
          </div>
        )}
      </div>
    </div>
  );
}

NestCard.propTypes = {
  nestNumber: PropTypes.number.isRequired,
  isInvalid: PropTypes.bool.isRequired,
  isSolving: PropTypes.bool.isRequired,
  solvingNestId: PropTypes.number,
};

NestCard.defaultProps = {
  solvingNestId: null,
};

export default NestCard;
